import { useCallback, useEffect, useRef } from 'react';

export function useDebouncedCallback<Args extends unknown[]>(callback: (...args: Args) => void, delay: number) {
	const callbackRef = useRef(callback);
	const timeoutRef = useRef<number | null>(null);

	useEffect(() => {
		callbackRef.current = callback;
	});

	useEffect(
		() => () => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		},
		[]
	);

	return useCallback(
		(...x: Args) => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = window.setTimeout(() => callbackRef.current(...x), delay);
		},
		[delay]
	);
}
